export default "__VITE_ASSET__CjY9m2Wu__"